// utils/fbclid.ts
import Cookies from 'js-cookie';

export function storeFbclidFromUrl() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get('fbclid');

  if (fbclid) {
    Cookies.set('fbclid', fbclid, { expires: 30 }); // persist for 30 days
  }
}